<!-- Final - Document Upload Widget -->
<template>
    <div class>
        <div class="card">
            <div class="card-header">
                <i class="ti ti-user"></i>
<!--                <span>&nbsp;&nbsp;&nbsp;{{ $t("FinalDocumentUploadTitle") }}</span>-->
            </div>
            <div class="card-body box-body">
                <!-- Final - Particulars of Previous life Policies/Proposals Question Widget (12) -->
                <div class="row">
                    <div class="container-fluid">
                        <div class v-for="(upload_type, index) in UploadTypes" :key="index">
                            <div class="h5-color">{{upload_type.upload_type}}</div>
                            <div class="border border-primary mb-2">
                                <div class="upload">
                                    <div class="example-btn">
                                          <input
                                                type="file"
                                                :data-code="upload_type.code"
                                                class="btn btn-primary m-3 upload_img"
                                                v-on:change="onFileChange"
                                                ref="file"
                                                accept="image/png, image/jpeg"
                                                multiple="multiple"
                                                :disabled="proposal_status == 5"
                                          />
                                          <div class="row">
                                                  <div v-for="item in filterUploadDocs(upload_type.code)" :key="item.id" class="col-md-4 col-sm-4 col-xs-12">
                                                  <div class="img-class" v-if="item.proposal_upload_type_id == upload_type.code">
                                                      <div class="file-upload-thumb">
                                                          <a v-bind:href="uploadPath + item.url" target="_blank">
                                                              <img
                                                                      v-bind:src="uploadPath + item.url"
                                                                      target="_blank"
                                                                      class="rounded mt-1 mb-1 ml-3"
                                                                      alt="No Preview"
                                                                      width="80"
                                                                      height="80"
                                                              />
                                                          </a>
                                                      </div>
                                                      <b-button type="button" block variant="danger" size="xs"
                                                                v-on:click="deleteUploadItem(item.id)">remove
                                                      </b-button>
                                                  </div>
                                              </div>
                                          </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FileUpload from 'vue-upload-component'
    import {mapState, mapActions} from "vuex";

    export default {
        name: "final-document-upload-widget",
        components: {
            FileUpload,
        },
        data() {
            return {
                index: 0,
                files1: [],
                files2: [],
                uploadPath:process.env.VUE_APP_FILE_UPLOAD_PATH
            }
        },
        computed: {
            ...mapState("proposal", [
                "customer_errors",
                "ProposerData",
                "VehicleData",
                "CustomerData",
                "ActionData",
                "UploadTypes",
                "UploadedDocs",
                "UploadedDocsHistory",
                "btnApprove",
                "UploadedDocsActions",
                "proposal_status"
            ]),
        },
        methods: {
            ...mapActions("proposal", [
                "UploadFile",
                "loadUploadedFiles",
                "getUploadTypes",
                "setBtnApproveStatus",
                "approveDocuments",
                "RemoveFile",
            ]),

            onFileChange(e) {
                let formData = new FormData();
                formData.append("proposal_id", this.$route.query.id);
                formData.append("p_doc_type", e.currentTarget.dataset.code);

                for (var i = 0; i < e.currentTarget.files.length; i++) {
                    let file = e.currentTarget.files[i];
                    console.log(file);
                    formData.append("files[" + i + "]", file);
                }
                this.UploadFile(formData);
            },
            approveClick(e) {
                let payload = {
                    q_ref_no: this.$route.params.ref_no,
                    action: "APPROVE",
                    p_doc_type: e.currentTarget.dataset.code
                };
                this.approveDocuments(payload);
            },
            returnClick(e) {
                let payload = {
                    q_ref_no: this.$route.params.ref_no,
                    action: "RETURN",
                    p_doc_type: e.currentTarget.dataset.code,
                    remarks: ""
                };
                this.approveDocuments(payload);
            },
            rejectClick(e) {
                let payload = {
                    q_ref_no: this.$route.params.ref_no,
                    action: "REJECT",
                    p_doc_type: e.currentTarget.dataset.code,
                    remarks: ""
                };
                this.approveDocuments(payload);
            },
            deleteUploadItem(img_id){
                let payload = {
                    file_id: img_id,
                };
                this.RemoveFile(payload).then((response) => {
                    if (!response.error) {
                        let payload = {
                            proposal_id: this.$route.query.id
                        };
                        this.loadUploadedFiles(payload);
                    }
                });
            },
            filterUploadDocs(type){
                return this.UploadedDocs.filter(file => {
                    return file.proposal_upload_type_id == type;
                });
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>

    .upload_img{
        width: 30%;
    }

    .img-class{
        border: 1px solid #ffc107 !important;
        border-radius: 0.25rem !important;
        padding: 10px;
        margin: 5px;
    }

    .file-upload-thumb{

    }

    .card-outline {
        position: relative !important;
        display: flex !important;
        flex-direction: column !important;
        min-width: 0 !important;
        word-wrap: break-word !important;
        background-clip: border-box !important;
        border: 1px solid #ffc107 !important;
        border-radius: 0.25rem !important;
        box-shadow: none !important;
    }

    .example-multiple label.btn {
        margin-bottom: 0 !important;
        margin-right: 1rem !important;
    }

    .example-multiple .upload {
        margin-bottom: 1rem !important;
    }

    @media (max-width: 769px) {
        .upload_img{
            width: 89%;
        }
    }
</style>

<!-- Language Data for Final - Document Upload Widget -->
<i18n>
    {
    "en": {
    "AreYouInGoodHealthQuestion": "Are you in good health ? If 'No', Give details",
    "Insured": "Insured",
    "Spouse": "Spouse"
    },
    "si": {
    "AreYouInGoodHealthQuestion": "Are you in good health ?",
    "Insured": "ජීවිත රක්ෂිතයා",
    "Spouse": "කලත්‍රයා"
    },
    "ta": {
    "AreYouInGoodHealthQuestion": "Are you in good health ?",
    "Insured": "பிரதான வாழ்க்கை",
    "Spouse": "வாழ்க்கைத்துணை"
    }
    }
</i18n>